import { trackEvent } from "./track";
import { leaveSitePrompt } from "./leaveSitePrompt";
import { escapeQuotes, normalizeWhitespace } from "./helpers/stringHelpers";
import getPageName from "./helpers/track/getPageName";
import getLinkText from "./helpers/getLinkText";
import isProductDetail from "./helpers/track/isProductDetail";

const groomLinks = function () {
    document.body.addEventListener("click", function(e) {
        const target = getTargetLink(e.target);
        if (target) {
            if ((isAnchorButton(target) || target.tagName === 'BUTTON') && target.closest(".hero-wrap") && !isProductDetail()) {
                pushHeroLinkEvent(target);
                return;
            }

            if (isFooterLink(target)) {
                pushFooterLinkEvent(target);
            }
            const link = target.getAttribute("href");
            const leaveSiteModal = document.querySelectorAll(".leaveSitePrompt");
            const linkText = normalizeWhitespace(target.innerText);

            switch (getLinkType(link)) {
                case "asset":
                    e.preventDefault();
                    window.open(link, target.target);
                    pushDownloadEvent(target);
                    couponLink(link, target);
                    break;
                case "external":
                    if (!target.classList.contains("leaveSitePrompt__button") && leaveSiteModal) { // If LeaveSitePrompt is Configured
                        leaveSitePrompt(e, target, leaveSiteModal);
                    } else{
                        if(!target.getAttribute("target")) { // Open External link on new tab as default if target is not set
                            e.preventDefault();
                            window.open(link, "_blank");
                        }
                        pushExternalLinkEvent(link, target);
                        couponLink(link, target);
                        if (target.dataset.linktype == "download" || target.hasAttribute("download")) {
                            pushExternalDownloadEvent(target);
                        }
                    }
                    break;
                case "internal":
                    couponLink(link, target);
                    if (target.closest(".rich-text")) { // if internal link is inside richtext
                        pushRichTextLinkEvent(target);
                    }else if (target.closest("header") && !hasTrackEvent(target)) { // if internal link is inside header and doesnt have 'track-event' dispatch
                        pushHeaderLinkEvent(target);
                    }else if (target.closest(".hero-wrap") && !isProductDetail() && !hasTrackEvent(target)) { // if internal link is inside hero and doesnt have 'track-event' dispatch
                        pushHeroLinkEvent(target);
                    }else if(!hasTrackEvent(target)) {
                        defaultbCtaEvents(link, linkText, target.dataset.context);
                    }
                    break;
                default:
            }
        }

    });
}

const isAnchorButton = (target) => target.tagName === "A" && !target.hasAttribute("href") && target.hasAttribute("@click") && !/'track-event'/.test(target.getAttribute("@click"));

const hasTrackEvent = (target) => target.hasAttribute("@click") && /'track-event'/.test(target.getAttribute("@click"));

const isFooterLink = (target) => target.closest("footer") && !/\\'track\\-event\\'/.test(target.getAttribute("@click")); // if internal link is inside footer and doesnt have 'track-event' dispatch

const getLinkType = function (link) {
    let origin = window.location.origin;
    let isInternal = new RegExp("^" + origin);

    // is Hash
    if (/^\\#[-\w\d_\s]*$/g.test(link)) {
        return "hash";
    }

    // is mailto
    if (/mailto:([^\\?]*)g/.test(link)) {
        return "mailto";
    }

    // is tel
    if (/tel:([^\\?]*)g/.test(link)) {
        return "tel";
    }

    // is externals
    if (/^((http|https):\/\/)?(([\w.-]*)\.([\w]))(\/[^\\?$]*)?/g.test(link) && !isInternal.test(link)) {
        return "external";
    }

    // is asset
    if (/^(\/(\.resources|\.imaging|dam|local\/dam|local\/\.resources|local\/\.imaging|author\/dam|author\/\.resources|author\/\.imaging)\/([\w\\/\-\\:\s\\%\\&\\#\\@]*).+)$/gi.test(link)) {
        return "asset";
    }

    // is internal
    if (/^(\/([\w\\/\-\\:\s\\%\\&\\#\\@\\?\\=]*)(.html|htm)*)$/gi.test(link) || isInternal.test(link)) {
        return "internal";
    }

    return null;
}

const couponLink = function (link, target) {
    const isEmailCoupon = link.toLowerCase().includes("mobile") || link.toLowerCase().includes("email");
    const isPrintCoupon = link.toLowerCase().includes("print");
    const linkText = normalizeWhitespace(target.innerText);
    
    if(link.includes('coupon')) {
        trackEvent({
            event: "click_coupon",
            name: linkText,
            coupon_name: linkText,
            event_type: "cta"
        });
        if(isEmailCoupon) {
            trackEvent({
                event: "email_coupon",
                name: linkText,
                coupon_name: linkText,
                event_type: "cta"
            });
        }
        if(isPrintCoupon) {
            trackEvent({
                event: "print_coupon",
                name: linkText,
                coupon_name: linkText,
                event_type: "cta"
            });
        }
    }
    
}

const getTargetLink = function (target) {
    let el = null;
    if (target.localName == "a") {
        el = target;
    } else {
        if (target.closest("a")) { // when anchor link has html tag inside
            el = target.closest("a");
        }
    }
    return el;
}

const getLinkSection = function (link, defaultValue) {
    let section = link.dataset.gtmsection;
    if (!section || section == "") {
        section = defaultValue;
    }
    return section;
}

const getLinkSubSection = function (link, defaultValue) {
    let subSection = link.dataset.gtmsubsection;
    if (!subSection || subSection == "") {
        subSection = defaultValue;
    }
    return subSection;
}

const getLinkElement = function (link) {
    let element = link.dataset.gtmelement;
    if (!element || element == "") {
        element = link.innerText;
        if (!element || element == "") {
            element = link.getAttribute("title"); // Use Link Title when link text is empty
        }
    }
    return element;
}

const getImgAltTitlefromLink = (anchor) => {
    if (!anchor) return "";
    const img = anchor.querySelector("img");
    if (!img) return "";
    const alt = img.getAttribute("alt");
    const title = img.getAttribute("title");
    if (alt && alt.trim() !== "") return alt.trim();
    if (title && title.trim() !== "") return title.trim();
    return "";
}

// Determine banner_name from an <img> inside the link: prefer alt, then title, else filename from src
const getBannerNameFromLink = (anchor) => {
    if (!anchor) return "";

    // 1) If it's a button, prefer its text or title
    const isButton = anchor.classList.contains('button') || anchor.tagName === 'BUTTON';
    if (isButton) {
        const text = anchor.textContent?.trim();
        const title = anchor.getAttribute("title")?.trim();
        if (text) return text;
        if (title) return title;
    }

    // 2) If it has an image, prefer image alt, then title, else filename from src
    const img = anchor.querySelector("img");
    if (img) {
        const alt = img.getAttribute("alt")?.trim();
        const imgTitle = img.getAttribute("title")?.trim();
        if (alt) return alt;
        if (imgTitle) return imgTitle;

        const src = img.getAttribute("src")?.trim() || "";
        if (src) {
            const withoutQuery = src.split("?")[0].split("#")[0];
            const segments = withoutQuery.split("/");
            try {
                return decodeURIComponent(segments[segments.length - 1] || "");
            } catch (e) {
                return segments[segments.length - 1] || "";
            }
        }
    }

    // 3) Fallback to anchor text or title
    const text = anchor.textContent?.trim();
    const title = anchor.getAttribute("title")?.trim();
    return text || title || "";
};

const defaultbCtaEvents = function (link, linkText, context) {
    trackEvent({
        event: "cmp_event",
        event_type: "cta",
        title: linkText,
        ...(context && { context }),

    });
    trackEvent({
        event: "click_cta",
        event_type: "click",
        element_text: linkText || "none",
        element_url: link || "none",
    });
}

const pushRichTextLinkEvent = function (target) {
    let linkText = escapeQuotes(target.innerText);
    let obj = { event: "cmp_event", event_type: "cta", title: linkText, context: "others", eventCategory: "navigation", eventAction: linkText, eventLabel: "quick links" };
    let image = target.querySelector("img");
    if (image) { // if link has image
        obj.eventLabel = "logo";
        let imageAlt = escapeQuotes(image.getAttribute("alt"));
        if (linkText == "" && imageAlt != "") {
            obj.linkText = imageAlt;
            obj.eventAction = imageAlt;
        }
    }
    trackEvent(obj);
}

const pushDownloadEvent = function (target) {
    const linkText = target.dataset.linktext || escapeQuotes(target.innerText);
    let link = target.getAttribute("href");
    let fileName = link.split("/").pop();
    let fileNameWithoutExtension = fileName.replace(/\.[^/.]+$/, "");
    let fileFormat = fileName.split(".").pop();
    const isPdf = fileFormat?.toLowerCase() === "pdf";
    const imageText = getImgAltTitlefromLink(target);

    trackEvent({
        event: "download",
        name: fileName,
        document_format: fileFormat,
        interaction_type: "download"
    });
    if (isPdf){
        trackEvent({
            event: "click_item_leaflet",
            event_type: "download",
            item_name: fileNameWithoutExtension,
            document_name: fileName,
            document_url: link,
            document_type: fileFormat,
        });
    }
    trackEvent({
        event: "file_download",
        element_text: linkText || imageText || "none",
        document_name: fileName,
        document_url: link,
        document_type: fileFormat,
        event_type: "download",
    });
}

const pushExternalDownloadEvent = function (target) {
    const linkText = target.dataset.linktext || escapeQuotes(target.innerText);
    let link = target.getAttribute("href");
    let fileName = link.split("/").pop();
    let fileFormat = fileName.split(".").pop();
    const isPdf = fileFormat?.toLowerCase() === "pdf";
    const imageText = getImgAltTitlefromLink(target);

    trackEvent({
        event: "download",
        name: linkText,
        url: target.getAttribute("href"),
        interaction_type: "download"
    });

    if (isPdf) {
        trackEvent({
            event: "click_item_leaflet",
            event_type: "download",
            item_name: fileName,
            document_name: fileName,
            document_url: link,
            document_type: fileFormat,
        });
    }

    trackEvent({
        event: "file_download",
        element_text: linkText || imageText || "none",
        document_name: fileName,
        document_url: link,
        document_type: fileFormat,
        event_type: "download",
    });
}

const pushExternalLinkEvent = function (link, target) {
    const linkText = getLinkText({ target, link });
    const pageName = getPageName();

    trackEvent({
        event: "outbound_link",
        url: link,
        interaction_type: "outbound_link"
    });
    trackEvent({
        event: "click_outbound_link",
        ...(linkText && {element_text: linkText}),
        element_url: link,
        event_type: "click",
        item_related: isProductDetail() ? pageName : 'none',
    });
}

const pushHeaderLinkEvent = function (link) {
    const section = getLinkSection(link, "header");
    const subSection = getLinkSubSection(link, "menu");
    const element = getLinkElement(link);

    const linkHref = link.getAttribute("href") || "";
    const linkText = link.textContent?.trim() || "";

    const image = link.querySelector("img");
    let imageAlt = "";
    if (image) { // if link has image
        imageAlt = escapeQuotes(image.getAttribute("alt"));
    }

    trackEvent({
        event: "navigation",
        section: section,
        sub_section: subSection,
        element: element,
        interaction_type: "navigation"
    });
    trackEvent({
        event: "click_menu",
        element_url: linkHref,
        element_text: linkText || imageAlt || "none",
        event_type: 'click',
    });
}

const pushHeroLinkEvent = function (link) {
    const linkHref = link.getAttribute("href") || "none";
    const bannerName = getBannerNameFromLink(link);

    trackEvent({
        event: "click_banner",
        banner_name: bannerName || "none",
        element_url: linkHref,
        event_type: 'click',
    });
}

const pushFooterLinkEvent = function (link) {
    const section = getLinkSection(link, "footer");
    const subSection = getLinkSubSection(link, "menu");
    const element = getLinkElement(link);
    const linkHref = link.getAttribute("href") || "";
    const linkText = link.textContent?.trim() || "";
    trackEvent({
        event: "navigation",
        section: section,
        sub_section: subSection,
        element: element,
        interaction_type: "navigation"
    });
    trackEvent({
        event: "click_footer",
        element_text: linkText || "none",
        element_url: linkHref || "none",
        event_type: "click",
    });
}

function init() {
    groomLinks();
}

export default { init, pushExternalDownloadEvent };
